import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-BoldItalicNew.woff2';
import woff from '../src/PPMori-BoldItalicNew.woff';

export const ppMoriBoldItalic: FontFaceSpec = {
  weight: 700,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
